import React, { Component } from "react";
import PropTypes from "prop-types";
import Card from "react-bootstrap/Card";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTachometerAlt } from '@fortawesome/free-solid-svg-icons'
import { faGasPump } from '@fortawesome/free-solid-svg-icons'
import { faCalendar } from '@fortawesome/free-solid-svg-icons'

export class CardComponent extends Component {
    render() {
        const {
            img,
            name,
            id,
            make,
            model,
            registration_year,
            registration_month,
            price,
            mileage,
            carUrl,
            fuel,
            power
        } = this.props;

        return (
            <Link
                style={{ cursor: "pointer", color: "black" }}
                to={carUrl}
            >
                <Card>
                    <Card.Img 
                        variant="top" 
                        src={img} 
                        className="card_image"
                    />
                    <span className="priceTag font-weight-bold">
                        {price.toLocaleString()} €
                    </span>
                    <Card.Body className="card_body">
                        <Card.Title>
                            <h5 className="font-weight-bold"> {name}</h5>
                        </Card.Title>
                        <div>
                            <p>
                                {make} {model}
                            </p>
                            <div>
                                <span>
                                    <FontAwesomeIcon icon={faTachometerAlt}  className="mr-1"/>
                                    {mileage} kms
                                </span>
                                <span className="mx-1">|</span>
                                {power} cv
                            </div>
                            <div>
                                <span>
                                    <FontAwesomeIcon icon={faGasPump}  className="mr-1"/>
                                    {fuel}
                                </span>
                            </div>
                            <p>
                                <span>
                                    <FontAwesomeIcon icon={faCalendar}  className="mr-1"/>
                                    {registration_year} - {registration_month}
                                </span>
                            </p>
                        </div>
                    </Card.Body>
                </Card>
            </Link>
        );
    }
}

CardComponent.propTypes = {
    img: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string
};

export default CardComponent;
